import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import {  PeoplePickerComponent } from '../components/people-picker.component';
import { CoreModule } from 'src/core/modules/core.Module';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    PeoplePickerComponent
  ],
  imports:[
    CoreModule,
    FormsModule,
    CommonModule
  ],
  exports:[
    PeoplePickerComponent
  ]
})
export class PeoplePickerComponentModule { }
